<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<!-- <img src="./assets/media/logos/logo-mini-md-1.png" alt="Logo" />
	<mat-spinner diameter="40"></mat-spinner> -->
</div>